import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import cloneDeep from 'lodash.clonedeep';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

export const _cloneArray = <T>(array: T[]): T[] => { 
  if (array) {
    return cloneDeep(array);
  }
  return array;
};
